import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { CanvasFrame } from '../types';

interface Props {
  connections: string[][];
  frames: CanvasFrame[];
  onChange: (connections: string[][]) => void;
}

/** Simpel formulier i.p.v. lijnen tekenen op het canvas -- twee dropdowns +
 * een lijst met verwijderbare paren (sectie 17: geen lijnen-slepen in v1). */
export default function CanvasConnectionsEditor({ connections, frames, onChange }: Props) {
  const [fromId, setFromId] = useState(frames[0]?.id || '');
  const [toId, setToId] = useState(frames[1]?.id || frames[0]?.id || '');

  const frameLabel = (id: string) => frames.find((f) => f.id === id)?.title || id;

  const addConnection = () => {
    if (!fromId || !toId || fromId === toId) return;
    onChange([...connections, [fromId, toId]]);
  };
  const removeConnection = (index: number) => onChange(connections.filter((_, i) => i !== index));

  return (
    <div className="space-y-2">
      <div className="space-y-1">
        {connections.length === 0 && <p className="text-xs text-slate-500">Nog geen verbindingen.</p>}
        {connections.map((pair, index) => (
          // eslint-disable-next-line react/no-array-index-key -- paren zijn niet uniek te identificeren buiten hun positie
          <div key={index} className="flex items-center gap-2 rounded-md border border-slate-800 bg-slate-900 px-2 py-1.5 text-sm text-slate-200">
            <span className="flex-1 truncate">{frameLabel(pair[0])} → {frameLabel(pair[1])}</span>
            <Button type="button" variant="ghost" size="icon" onClick={() => removeConnection(index)} aria-label="Verbinding verwijderen">
              <Trash2 className="h-3.5 w-3.5" />
            </Button>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Select value={fromId} onValueChange={setFromId}>
          <SelectTrigger className="w-36"><SelectValue placeholder="Van" /></SelectTrigger>
          <SelectContent>{frames.map((f) => <SelectItem key={f.id} value={f.id}>{f.title || f.id}</SelectItem>)}</SelectContent>
        </Select>
        <span className="text-slate-500">→</span>
        <Select value={toId} onValueChange={setToId}>
          <SelectTrigger className="w-36"><SelectValue placeholder="Naar" /></SelectTrigger>
          <SelectContent>{frames.map((f) => <SelectItem key={f.id} value={f.id}>{f.title || f.id}</SelectItem>)}</SelectContent>
        </Select>
        <Button type="button" variant="outline" size="sm" onClick={addConnection} disabled={!fromId || !toId || fromId === toId}>
          <Plus className="mr-1 h-3.5 w-3.5" /> Toevoegen
        </Button>
      </div>
    </div>
  );
}
